<template>
  <section :class="this.$Base.checkSysteam() == 'MOBILE' ? 'minfo' : 'info'">
    <!-- header -->
    <div
      v-if="this.$Base.checkSysteam() == 'MOBILE'"
      :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mheader' : 'header'"
    >
      <!-- <div class="nav">
        <img src="../../assets/nav.png" alt="" />
      </div> -->
      <div class="logo">
        <img src="../../assets/logo.png" alt="" />
      </div>
    </div>
    <div class="header" v-if="this.$Base.checkSysteam() == 'PC'">
      <div class="header-in" :class="isShow == true ? 'pcWid' : ''">
        <div class="head-left" v-if="isShow">
          <div class="logo">
            <img src="../../assets/logo.png" alt="" />
          </div>
        </div>
        <div class="infoTitle">{{ $t("message.infoTitle") }}</div>
      </div>
    </div>
    <!-- 内容 -->
    <div
      class="infos"
      :class="
        isShow == true && this.$Base.checkSysteam() == 'PC' ? 'infosWid' : ''
      "
    >
      <Rastar-Tc v-if="isShowLang == 1"></Rastar-Tc>
      <Rastar-Th v-if="isShowLang == 2"></Rastar-Th>
      <Rastar-En v-if="isShowLang == 3"></Rastar-En>
    </div>

    <!-- 底部 -->
    <rastar-footer></rastar-footer>
  </section>
</template>

<script>
import rastarFooter from "./../../components/footer/template.vue";
import RastarTc from "./../../components/infopage/tc/template.vue";
import RastarTh from "./../../components/infopage/th/template.vue";
import RastarEn from "./../../components/infopage/en/template.vue";
export default {
  name: "ldy",
  data() {
    return {
      urlData: null,
      isMsgVal: 0,
      isShowLang: 0,
      isShow: true,
      screenWidth: document.documentElement.clientWidth, //视口宽
      systemVal: this.$Base.checkSysteam(),
    };
  },
  props: ["appId", "pId", "mdId", "ukey", "msgVal"],
  components: {
    rastarFooter,
    RastarTc,
    RastarTh,
    RastarEn,
  },
  created() {
    // 把页面链接存起来支付的时候需要调用
    this.$Storage.setCookie("msrGameUrl", window.location.href, 7);
    // 根据语言显示对应的教程内容
    let langVal = this.$Storage.localStorageGet("lang");
    if (langVal.substring(0, 2) == "zh") {
      this.isShowLang = 1;
    } else if (langVal.substring(0, 2) == "th") {
      this.isShowLang = 2;
    } else {
      this.isShowLang = 3;
    }
    if (this.screenWidth < 1100 && this.systemVal == "PC") {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  mounted() {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.documentElement.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        if (this.screenWidth < 1100 && this.systemVal == "PC") {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log(that.screenWidth);
          that.timer = false;
        }, 400);
      }
    },
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
